// src/components/handover/LockedHandoverNotice.jsx
import React from 'react';
import { cardStyle, sectionTitleStyle } from '../../handover/handoverStyles';
import HandoverPdfDownloadButton, {
  canDownloadHandoverPdf,
} from './HandoverPdfDownloadButton';

export default function LockedHandoverNotice({
  mode,
  handover,
  claims,
  pushAlert,
}) {
  const title =
    mode === 'pickup'
      ? 'Pick-up handover already completed'
      : 'Return handover already completed';

  return (
    <section style={cardStyle()}>
      <h3 style={sectionTitleStyle}>{title}</h3>
      <p style={{ fontSize: 13, color: '#4b5563' }}>
        This {mode === 'pickup' ? 'pick-up' : 'return'} form has already been
        submitted and is locked for editing.
      </p>

      {handover && (
        <p style={{ fontSize: 12, color: '#6b7280', marginTop: 6 }}>
          Completed on:{' '}
          {handover.createdAt
            ? (() => {
              const d = new Date(handover.createdAt);
              const day = String(d.getDate()).padStart(2, '0');
              const month = String(d.getMonth() + 1).padStart(2, '0');
              const year = d.getFullYear();
              const time = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

              return `${day}/${month}/${year} ${time}`;
            })()
            : '—'}
          <br />
          Customer: {handover.customerName || '—'}
        </p>
      )}

      {handover?.id && canDownloadHandoverPdf(claims?.groups || []) && (
        <HandoverPdfDownloadButton
          handoverId={handover.id}
          onError={pushAlert}
        />
      )}
    </section>
  );
}
